import { getTranslations } from './data/translations';

export type Translations = keyof ReturnType<typeof getTranslations>;
type Args = Record<string, string>;

export function useTranslation() {

  const t = (key: Translations, args: Args = {}) => {
    const translation = getTranslations()[key];
    return interpolate(translation, args);
  };

  return {
    t,
  };
}

const interpolate = (translation: string, args: Args) => {
  if (isEmptyObject(args)) {
    return translation;
  }

  return translation.replace(/\{\{(.*?)\}\}/g, (_, key) => {
    const value = args[key.trim()];
    return value !== undefined
      ? value
      : `{{${key}}}`; // Default to original placeholder if no match
  });
};

const isEmptyObject = (args: Args) => {
  return !!Object.keys(args).length;
};
